import React from "react";

// Lightweight CSS spinner. Styles live in styles/layout/_settingsPopup.scss
// (.circleLoader). Pass a className for layout/centering by the consumer.
const CircleLoader = (props) => {
  const { className = "" } = props || {};
  return (
    <div className={`circleLoaderWrap ${className}`}>
      <span className="circleLoader" />
    </div>
  );
};

export default CircleLoader;
